
import React from "react";
import { Link } from "react-router-dom";
import "./Gear.css";

import img8605 from "../images/gear/gera-oil/8605/8605_1front.webp";
import img8614 from "../images/gear/gera-oil/8614/8614_1front.webp";
import img8615 from "../images/gear/gera-oil/8615/8615_1front.webp";
import img8616 from "../images/gear/gera-oil/8616/8616_1front.webp";
import img8701 from "../images/gear/gera-oil/8701/8701_1front.webp";
import img8702 from "../images/gear/gera-oil/8702/8702_1front.webp";
import img8710 from "../images/gear/gera-oil/8710/8710_1front.webp";

const motorSections = [
  // {
  //   id: "transmission-fluid",
  //   title: "Automatic transmission fluids",
  //   products: [
  //     {
  //       id: "8605",
  //       name: "FANFARO ATF SP-IV 8605",
  //       image: img8605,
  //     },
  //     {
  //       id: "8614",
  //       name: "FANFARO AZF 8 8614",
  //       image: img8614,
  //     },
  //     {
  //       id: "8615",
  //       name: "FANFARO ATF VI 8615",
  //       image: img8615,
  //     },
  //     {
  //       id: "8616",
  //       name: "FANFARO DCT 8616",
  //       image: img8616,
  //     },
  //   ],
  // },

  {
    id: "gear-oil",
    title: "Gear Oil",
    products: [
     
       {
        id: "8605",
        name: "FANFARO ATF SP-IV 8605",
        image: img8605,
      },
      {
        id: "8614",
        name: "FANFARO AZF 8 8614",
        image: img8614,
      },
      {
        id: "8615",
        name: "FANFARO ATF VI 8615",
        image: img8615,
      },
      {
        id: "8616",
        name: "FANFARO DCT 8616",
        image: img8616,
      },
       {
        id: "8701",
        name: "FANFARO MAX 4 80W-90 GL-4 8701",
        image: img8701,
      },
      {
        id: "8702",
        name: "FANFARO MAX 4+ 75W-90 GL-4+ 8702",
        image: img8702,
      },
      {
        id: "8710",
        name: "FANFARO MAX 7 75W-80 8710",
        image: img8710,
      },
    ],
  },
];

const Motor = () => {
  return (
    <div className="car-v4-page">
      <br />

      <nav className="app-breadcrumb">
        <Link to="/">Home</Link>
        <span className="separator">›</span>

        <Link to="/products">Products</Link>
        <span className="separator">›</span>

        <span className="current">
          Gear oils & transmission fluids
        </span>
      </nav>

      {motorSections.map((section) => (
        <section
          key={section.id}
          className="car-v4-section"
        >
          {/* Category title */}
          <h2 className="car-v4-heading">
            {section.title}
          </h2>

          {/* Products in this category */}
          <div className="car-v4-grid">
            {section.products.map((product) => (
              <Link
                key={product.id}
                to={`/products/gear-oils-transmission-fluids/gear-oils/${section.id}/${product.id}`}
                className="car-v4-card"
              >
                <div className="car-v4-img">
                  <img
                    src={product.image}
                    alt={product.name}
                  />
                </div>

                <div className="car-v4-content">
                  <span className="car-v4-name">
                    {product.name}
                  </span>

                  <span className="car-v4-arrow-wrap">
                    <span className="car-v4-arrow">
                      →
                    </span>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default Motor;
